export default function Blog() {
  return (
    <section className="max-w-5xl mx-auto px-6 py-16 text-center">
      <h2 className="text-4xl font-bold text-blue-600 mb-10">
        Popalooza Blog
      </h2>

      <div className="bg-white rounded-lg shadow-md p-10">
        <p className="text-lg text-gray-700 leading-relaxed">
          ✨ Blog content coming soon! Stay tuned for updates, tips, and behind‑the‑scenes stories from Popalooza.
        </p>
      </div>
    </section>
  );
}
